import {
  IBenefitFilters,
  IBenefitListResponse,
  IBenefitSendResponse,
  IBenefitStats,
  IBenefitStatsResponse,
  IBenefitUploadResponse,
} from "../interfaces/benefit";
import { downloadBlob, getFileNameFromDisposition } from "../utils/download";
import api from "./api";

/** Listado paginado y filtrado de la tabla */
export const getBenefitList = async (params: {
  page: number;
  limit: number;
  filters: IBenefitFilters;
}): Promise<IBenefitListResponse> => {
  const { page, limit, filters } = params;

  const { data } = await api.post<IBenefitListResponse>(
    "benefit/list",
    { filters },
    { params: { page, limit } }
  );

  return data;
};

/** Totales globales para las tarjetas de resumen */
export const getBenefitStats = async (): Promise<IBenefitStats> => {
  const { data } = await api.get<IBenefitStatsResponse>("benefit/stats");
  return data.stats;
};

/** Carga la nomina. El excel de resultado vuelve en base64 dentro del json */
export const uploadBenefitExcel = async (params: {
  file: File;
  user?: string;
}): Promise<IBenefitUploadResponse> => {
  const { file, user } = params;
  const form = new FormData();
  form.append("file", file);

  const { data } = await api.post<IBenefitUploadResponse>("benefit/upload", form, {
    params: user ? { user } : undefined,
  });

  return data;
};

/** Dispara el envio de la plantilla a todos los registros sin fecha de envio */
export const sendBenefitMessages = async (): Promise<IBenefitSendResponse> => {
  const { data } = await api.post<IBenefitSendResponse>("benefit/send");
  return data;
};

/** Descarga el excel de resultados respetando los filtros aplicados */
export const exportBenefits = async (params: {
  filters: IBenefitFilters;
}): Promise<void> => {
  const { filters } = params;

  const response = await api.post(
    "benefit/export",
    { filters },
    { responseType: "blob" }
  );

  downloadBlob({
    blob: response.data as Blob,
    fileName: getFileNameFromDisposition({
      disposition: response.headers["content-disposition"] as string | undefined,
      fallback: "beneficios.xlsx",
    }),
  });
};

/** Descarga la plantilla de carga */
export const downloadBenefitTemplate = async (): Promise<void> => {
  const response = await api.get("benefit/template", { responseType: "blob" });

  downloadBlob({
    blob: response.data as Blob,
    fileName: getFileNameFromDisposition({
      disposition: response.headers["content-disposition"] as string | undefined,
      fallback: "benefits-template.xlsx",
    }),
  });
};
